import {
    Button,
    Checkbox,
    Divider,
    FormControlLabel,
    InputAdornment,
    Link,
    TextField,
    useMediaQuery,
} from "@mui/material";
import styles from "./login.module.css";
import MailIcon from "@mui/icons-material/Mail";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userCreds } from "../../data";

const Login = () => {
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [loginCreds, setLoginCreds] = useState({
        username: "",
        password: "",
    });

    const loginAdmin = () => {
        console.log(userCreds, loginCreds)
        if(userCreds.email === loginCreds.username && userCreds.password === loginCreds.password){
            localStorage.setItem("auth", "admin");
            navigate("/dashboard/");
        }
    };

    const isSmallScreen = useMediaQuery("(max-width:600px)");

    return (
        <div className={styles.loginPageContainer}>
            <video autoPlay muted loop playsInline className={styles.bgVideo}>
                <source src="/assets/videos/loginbg.mp4" type="video/mp4" />
            </video>
            <div
                className={`${
                    isSmallScreen ? styles.overlaybgMobile : styles.overlaybg
                } hideScrollbar smooth-scroll`}
            >
                <div className={styles.loginMainContainer}>
                    <div
                        className={`${styles.loginDescBox} flex-col-direction`}
                    >
                        <div className="d-flex gap-3">
                            <div style={{ width: 52, height: 52 }}>
                                <img
                                    src="/phicode_light.png"
                                    alt="Phicode"
                                    width={"100%"}
                                />
                            </div>
                            <div
                                style={{
                                    color: "var(--color-font)",
                                    fontSize: "200%",
                                }}
                            >
                                Phicode
                            </div>
                        </div>
                        <div>
                            Lorem ipsum, dolor sit amet consectetur adipisicing
                            elit.
                        </div>
                    </div>
                    <div className={styles.loginInputBox}>
                        <div
                            className={`${styles.loginTitle} flex-col-direction`}
                        >
                            <div>Welcome To</div>
                            <div>PhiScan.AI</div>
                        </div>
                        <div className={styles.loginInputs}>
                            <div className={styles.loginInputInner}>
                                <div className={styles.textFields}>
                                    <TextField
                                        label="Email*"
                                        variant="outlined"
                                        size="medium"
                                        sx={{ width: "100%" }}
                                        value={loginCreds.email}
                                        onChange={(e) =>
                                            setLoginCreds((prev) => ({
                                                ...prev,
                                                username: e.target.value,
                                            }))
                                        }
                                        onKeyDown={(e) =>
                                            e.key === "Enter" && loginAdmin()
                                        }
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <MailIcon
                                                        fontSize="12"
                                                        sx={{
                                                            color: "#00CFFF",
                                                        }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    <TextField
                                        label="Password*"
                                        variant="outlined"
                                        size="medium"
                                        type={visible ? "text" : "password"}
                                        sx={{ width: "100%" }}
                                        value={loginCreds.password}
                                        onChange={(e) =>
                                            setLoginCreds((prev) => ({
                                                ...prev,
                                                password: e.target.value,
                                            }))
                                        }
                                        onKeyDown={(e) =>
                                            e.key === "Enter" && loginAdmin()
                                        }
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <LockIcon
                                                        fontSize="12"
                                                        sx={{
                                                            color: "#00CFFF",
                                                        }}
                                                    />
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                    onClick={() =>
                                                        setVisible(
                                                            (prev) => !prev
                                                        )
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {visible ? (
                                                        <VisibilityOffIcon
                                                            fontSize="12"
                                                            sx={{
                                                                color: "#00CFFF",
                                                            }}
                                                        />
                                                    ) : (
                                                        <VisibilityIcon
                                                            fontSize="12"
                                                            sx={{
                                                                color: "#00CFFF",
                                                            }}
                                                        />
                                                    )}
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <FormControlLabel
                                        control={<Checkbox size="medium" />}
                                        label="Keep me Signed in"
                                        color="primary"
                                    />
                                    <Link href="#" color="#ccdaf0" fontSize={8}>
                                        Reset Passowrd
                                    </Link>
                                </div>
                                <Button
                                    sx={{ marginTop: 2 }}
                                    variant="customCyan"
                                    size="large"
                                    fullWidth
                                    
                                    onClick={loginAdmin}
                                >
                                    Login
                                </Button>
                            </div>
                        </div>
                        <Divider
                            sx={{
                                borderColor: "cyan",
                                color: "cyan",
                                opacity: 0.5,
                                "&::before, &::after": {
                                    borderColor: "cyan",
                                },
                                mx: 7,
                            }}
                        >
                            or
                        </Divider>

                        <div
                            className={`${styles.loginSocial} flex-row-direction`}
                        >
                            <Button variant="customContained">
                                <img
                                    src="/assets/icons/google.png"
                                    alt="google"
                                    width={20}
                                />
                            </Button>
                            <Button variant="customContained">
                                <img
                                    src="/assets/icons/azure.png"
                                    alt="azure"
                                    width={20}
                                />
                            </Button>
                        </div>
                        <div
                            className={`${styles.loginHelp} flex-row-direction`}
                        >
                            <div>
                                Need Help?{" "}
                                <Link
                                    href="#"
                                    color="rgba(255, 255, 255, 0.56)"
                                >
                                    Contact your Admin
                                </Link>
                            </div>
                            <div>
                                New User?{" "}
                                <Link
                                    href="#"
                                    color="rgba(255, 255, 255, 0.56)"
                                >
                                    Request Access
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
